import React, { useEffect, useState } from "react";
import HorizontalRule from "../../../components/components/atoms/HorizontalRule";
import { Button, Heading, Notification } from "@telia/teddy";
import { useSelector } from "react-redux";
import PAGES from "../../../../../constants/pages";
import { RootState } from "../../../../../models";
import { getContentfulFeatureToggles, getOrderId } from "../../../app/state/selectors";
import ConnectedShoppingCart from "../../../navigation/components/organisms/ConnectedShoppingCart/ConnectedShoppingCart";
import { Header } from "../../components/atoms/Header";
import ContactCard from "../../components/molecules/ContactCard/ContactCard";
import ContractSection from "../Orders/OrderDetail/ContractSection";
import { getCustomerLegalOwnerIndividual } from "../../state/selectors/customerSelectors";
import { getSelectedAgent } from "../../state/selectors/selectors";
import ReceiptReviewModal from "./ReceiptReviewModal";
import "./Summary.less";

const Receipt = () => {
    const [isReviewModalOpen, setIsReviewModalOpen] = useState(false);
    const orderId = useSelector((state: RootState) => getOrderId(state));

    const showNexusFeedbackModalAtReceiptPage = useSelector(
        (state: RootState) => !!getContentfulFeatureToggles(state).showNexusFeedbackModalAtReceiptPage,
    );
    const legalOwner = useSelector((state: RootState) => getCustomerLegalOwnerIndividual(state));
    const salesAgent = useSelector((state: RootState) => getSelectedAgent(state));

    const legalOwnerFullName = `${legalOwner?.firstName || ""} ${legalOwner?.lastName || ""}`.trim();
    const legalOwnerAddress = legalOwner?.street || "";
    const legalOwnerCity = legalOwner?.city || "";
    const legalOwnerEmail = legalOwner?.email || "";
    const legalOwnerPhone = legalOwner?.phone || "";

    const salesAgentFullName = `${salesAgent?.firstName || ""} ${salesAgent?.lastName || ""}`.trim();

    useEffect(() => {
        if (!showNexusFeedbackModalAtReceiptPage) {
            setIsReviewModalOpen(false);
            return;
        }

        const openTimer = window.setTimeout(() => {
            setIsReviewModalOpen(true);
        }, 25000); // Show after 25 seconds

        return () => window.clearTimeout(openTimer);
    }, [showNexusFeedbackModalAtReceiptPage]);

    return (
        <div className="retailer-dashboard-wrapper">
            <Header text="Kvittering" />
            <div className="retailer-main-section">
                <Notification type="tile" variant="success" className="success" mb="200">
                    <Notification.Icon />
                    <Notification.Text>
                        <strong>Kjøp fullført</strong>
                        {orderId && (
                            <>
                                <br />
                                Ordrenummer: {orderId}
                            </>
                        )}
                    </Notification.Text>
                </Notification>
                <div>
                    <ConnectedShoppingCart isRetailer useStandalone={true} heading="Handlekurv" />
                </div>
                <HorizontalRule />
                <div className="retailer-summary-contact-cards">
                    <div className="retailer-summary-contact-card-section">
                        <Heading as="h2" variant="title-100" mb="50">
                            Kunde
                        </Heading>
                        <ContactCard
                            name={legalOwnerFullName}
                            address={legalOwnerAddress}
                            city={legalOwnerCity}
                            contactPhone={legalOwnerPhone}
                            contactEmail={legalOwnerEmail}
                        />
                    </div>
                    {salesAgent && (
                        <div className="retailer-summary-contact-card-section">
                            <Heading as="h2" variant="title-100" mb="50">
                                Salgsagent
                            </Heading>
                            <ContactCard name={salesAgentFullName} address="" city="" />
                        </div>
                    )}
                </div>
                <HorizontalRule />
                <div className="retailer-summary-contract-section">
                    {orderId && <ContractSection orderId={orderId} />}
                </div>
                <HorizontalRule />
                <div className="retailer-summary-actions">
                    <Button
                        variant="tertiary-purple"
                        onClick={() => {
                            window.location.assign(PAGES.RETAILER.NEWORDER.URL);
                        }}
                    >
                        Start ny ordre
                    </Button>
                </div>
            </div>
            {showNexusFeedbackModalAtReceiptPage && (
                <ReceiptReviewModal open={isReviewModalOpen} onOpenChange={setIsReviewModalOpen} />
            )}
        </div>
    );
};

export default Receipt;
